import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoHeader } from "../../../assets/index";
import { RefreshButton } from "../../atoms";
import "./Profile.css";

import { useDispatch, useSelector } from "react-redux";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import { getExcoPusat } from "../../../config/Redux/ExcoPusat/actions";
import SkeletonProfile from "./SkeletonProfile";
import DownloadDaftarAnggota from "./downloadDaftarAnggota";
import DownloadPengurusKabkot from "./downloadPengurusKabkot";
import DownloadPengurusKecamatan from "./downloadPengurusKecamatan";
import DownloadPengurusProvinsi from "./downloadPengurusProvinsi";
import DownloadPengurusPusat from "./downloadPengurusPusat";
import DownloadRekapAnggota from "./downloadRekapAnggota";
import DownloadRekapPerempuan from "./downloadRekapPerempuan";

// Slide transition for fullscreen dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [refreshRotate, setRefreshRotate] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(true);

  const dataExcoPusat = useSelector((state) => state.excopusat.dataExcoPusat);
  const isLoading = useSelector((state) => state.excopusat.isLoading);
  const data = dataExcoPusat?.data?.data?.[0]; // First item is EXCO Pusat

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  useEffect(() => {
    // Check if data already exists (cache check)
    if (!dataExcoPusat?.data?.data?.length) {
      dispatch(getExcoPusat());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Handle download loading state
  useEffect(() => {
    if (openDownload) {
      setDownloadLoading(true);
      // Hide loading after components have time to fetch data
      const timer = setTimeout(() => {
        setDownloadLoading(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [openDownload]);

  const handleRefresh = async () => {
    setRefreshRotate(true);
    const response = await dispatch(getExcoPusat());
    if (response) {
      setRefreshRotate(false);
    }
  };

  // Handle Lock/Unlock

  const renderStatus = (isFilled) => {
    return isFilled === 1 ? (
      <span className="profile-row-value status-filled">Terisi</span>
    ) : (
      <span className="profile-row-value" style={{ color: "#e53935" }}>
        Belum Terisi
      </span>
    );
  };

  // Format alamat object to string
  const formatAlamat = (alamatObj) => {
    if (!alamatObj) return "Gedung FSPMI Lt.3, Jl. Raya Pondok Gede.";

    const parts = [
      alamatObj.alamat_detail,
      alamatObj.nama_kelurahan,
      alamatObj.nama_kecamatan,
      alamatObj.nama_kab_kot,
      alamatObj.nama_provinsi,
    ].filter(Boolean);

    return parts.length > 0
      ? parts.join(", ")
      : "Gedung FSPMI Lt.3, Jl. Raya Pondok Gede.";
  };

  // Calculate selisih (migrasi)

  // Calculate Completion Counts
  const calculateCompletion = () => {
    let kantor = 0;
    if (data?.status_dokumen?.foto_kantor === 1) kantor++;
    if (data?.status_dokumen?.sewa_kantor === 1) kantor++;
    if (data?.status_dokumen?.domisili === 1) kantor++;

    let bank = 0;
    if (data?.data_bank?.no_rekening) bank++;
    if (data?.data_bank?.nama_bank) bank++;
    if (data?.status_dokumen?.rekening === 1) bank++;

    let kepengurusan = 0;
    if (data?.total_pengurus) kepengurusan++;
    if (data?.nomer_sk_pengurus) kepengurusan++;
    if (data?.tanggal_sk) kepengurusan++;
    if (data?.status_dokumen?.sk_pengurus === 1) kepengurusan++;

    let legalitas = 0;
    if (data?.status_dokumen?.sk_menkumham === 1) legalitas++;
    if (data?.status_dokumen?.menkumham_ad_art === 1) legalitas++;
    if (data?.status_dokumen?.badan_hukum === 1) legalitas++;
    if (data?.status_dokumen?.akta_notaris_pendirian === 1) legalitas++;
    if (data?.status_dokumen?.lambang_partai === 1) legalitas++;

    return { kantor, bank, kepengurusan, legalitas };
  };

  const counts = calculateCompletion();

  // Show skeleton if loading, refreshing, or no data yet
  if (isLoading || refreshRotate || (!data && !dataExcoPusat?.data)) {
    return <SkeletonProfile />;
  }

  return (
    <>
      {/* Alert Message */}

      <div className="profile-container">
        {/* Left Panel */}
        <div className="profile-left-panel">
          {/* Profile Card */}
          <div className="profile-card">
            <div className="profile-logo-section">
              <img
                src={logoHeader}
                alt="Partai Buruh"
                className="profile-logo"
              />
              <h2 className="profile-party-name">Partai Buruh</h2>
            </div>

            <div className="profile-address">
              <LocationOnOutlinedIcon className="profile-address-icon" />
              <div>
                <p className="profile-address-label">Alamat</p>
                <p className="profile-address-text">
                  {formatAlamat(data?.alamat)}
                </p>
              </div>
            </div>
            <h3 className="profile-bank-title">Kantor {counts.kantor}/3</h3>

            {/* Document Links */}
            <div className="profile-doc-link">
              <p className="profile-doc-label">Foto Kantor</p>
              {renderStatus(data?.status_dokumen?.foto_kantor)}
            </div>
            <div className="profile-doc-link">
              <p className="profile-doc-label">
                Dokumen Surat Perjanjian Sewa Kantor
              </p>
              {renderStatus(data?.status_dokumen?.sewa_kantor)}
            </div>
            <div className="profile-doc-link">
              <p className="profile-doc-label">Dokumen Surat Domisili Kantor</p>
              {renderStatus(data?.status_dokumen?.domisili)}
            </div>
          </div>

          {/* Bank Card */}
          <div className="profile-card">
            <h3 className="profile-bank-title">
              Rekening Bank {counts.bank}/3
            </h3>
            <div className="profile-doc-link">
              <p className="profile-doc-label">No.Rekening</p>
              {renderStatus(data?.data_bank?.no_rekening ? 1 : 0)}
            </div>
            <div className="profile-doc-link">
              <p className="profile-doc-label">Nama Bank</p>
              {renderStatus(data?.data_bank?.nama_bank ? 1 : 0)}
            </div>
            <div className="profile-doc-link">
              <p className="profile-doc-label">Buku Rekening</p>
              {renderStatus(data?.status_dokumen?.rekening)}
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="profile-right-panel">
          <div className="profile-actions-sticky">
            <button
              className="exco-btn-lihat-dokumen"
              onClick={() => {
                const officeId = data?.id_kantor_exco;
                const tingkatExcoId = data?.tingkat_exco?.id || 1;

                navigate(`/dokumen-pusat/${officeId}/${tingkatExcoId}`);
              }}
            >
              Lihat Dokumen
            </button>
            <RefreshButton onClick={handleRefresh} loading={refreshRotate} />
          </div>

          {/* Kepengurusan Section */}
          <div className="profile-section">
            <h3 className="profile-section-header">
              Kepengurusan {counts.kepengurusan}/4
            </h3>
            <div className="profile-section-content">
              <div className="profile-row">
                <p className="profile-row-label">Jumlah Pengurus</p>
                <p className="profile-row-value">
                  {data?.total_pengurus || "-"}
                </p>
              </div>
              <div className="profile-row">
                <p className="profile-row-label">Jumlah Pengurus Perempuan</p>
                <p className="profile-row-value">
                  {data?.total_pengurus_perempuan
                    ? `${Math.round((data?.total_pengurus_perempuan / data?.total_pengurus) * 100)}%`
                    : "-"}
                </p>
              </div>
              <div className="profile-row">
                <p className="profile-row-label">No. SK Pengurus Harian</p>
                <p className="profile-row-value">
                  {data?.nomer_sk_pengurus || "-"}
                </p>
              </div>
              <div className="profile-row">
                <p className="profile-row-label">Tanggal SK Pengurus Harian</p>
                <p className="profile-row-value">
                  {data?.tanggal_sk
                    ? data.tanggal_sk
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    : "-"}
                </p>
              </div>
              <div className="profile-row">
                <p className="profile-row-label">SK Pengurus Harian</p>
                {renderStatus(data?.status_dokumen?.sk_pengurus)}
              </div>

              <div className="profile-row">
                <p className="profile-row-label">
                  Surat Menkumham Lambang Partai
                </p>
                {renderStatus(data?.status_dokumen?.lambang_partai_menkumham)}
              </div>
              <div className="profile-row">
                <p className="profile-row-label">Surat Pernyataan Model F</p>
                {renderStatus(data?.status_dokumen?.surat_pernyataan_model_f)}
              </div>
            </div>
          </div>
          {/* Legalitas Section */}
          <div className="profile-section">
            <h3 className="profile-section-header">
              Legalitas {counts.legalitas}/5
            </h3>
            <div className="profile-section-content">
              <div className="profile-row">
                <p className="profile-row-label">SK Menkum EXCO Pusat</p>
                {renderStatus(data?.status_dokumen?.sk_menkumham)}
              </div>
              <div className="profile-row">
                <p className="profile-row-label">SK Menkum AD/ART</p>
                {renderStatus(data?.status_dokumen?.menkumham_ad_art)}
              </div>
              <div className="profile-row">
                <p className="profile-row-label">Dokumen Badan Hukum BNRI</p>
                {renderStatus(data?.status_dokumen?.badan_hukum)}
              </div>
              <div className="profile-row">
                <p className="profile-row-label">SK Akta Notaris ADRT</p>
                {renderStatus(data?.status_dokumen?.akta_notaris_pendirian)}
              </div>
              <div className="profile-row">
                <p className="profile-row-label">
                  Dokumen Lambang Partai Buruh
                </p>
                {renderStatus(data?.status_dokumen?.lambang_partai)}
              </div>
            </div>
          </div>

          {/* Lampiran PKPU Section */}
          {checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") && (
            <div className="profile-section">
              <h3 className="profile-section-header">Lampiran PKPU</h3>
              <div className="profile-section-content">
                <div className="profile-row">
                  <p className="profile-row-label">
                    Susunan Pengurus Tingkat Pusat
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("pengurus pusat")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Susunan Pengurus Tingkat Provinsi
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("pengurus provinsi")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Susunan Pengurus Tingkat Kab/Kota
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("pengurus kabkot")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Susunan Pengurus Tingkat Kecamatan
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("pengurus kecamatan")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Rekapitulasi Keterwakilan Perempuan
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("rekap perempuan")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Rekapitulasi Jumlah Anggota Partai Politik
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("rekap anggota")}
                  >
                    Download
                  </span>
                </div>
                <div className="profile-row">
                  <p className="profile-row-label">
                    Daftar Nama dan Alamat Anggota Partai Politik
                  </p>
                  <span
                    className="profile-row-value download-link"
                    onClick={() => setOpenDownload("daftar anggota")}
                  >
                    Download
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Download Dialog with Modern MUI Fullscreen */}
        <Dialog
          fullScreen
          open={!!openDownload}
          onClose={() => setOpenDownload(false)}
          TransitionComponent={Transition}
          sx={{
            "& .MuiDialog-paper": {
              backgroundColor: "#f8f9fa",
            },
          }}
        >
          {/* Content - Download Components with Loading */}
          <div
            style={{
              padding: 0,
              overflow: "auto",
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Loading Indicator */}
            {downloadLoading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "80px 40px",
                  gap: 16,
                }}
              >
                <CircularProgress
                  size={48}
                  thickness={3}
                  sx={{ color: "#f36f21" }}
                />
                <span style={{ fontSize: 14, color: "#666", fontWeight: 500 }}>
                  Memuat data dokumen...
                </span>
              </div>
            )}

            {/* Download Components - Hide during loading but render to trigger data fetch */}
            <div
              style={{ display: downloadLoading ? "none" : "block", flex: 1 }}
            >
              {openDownload === "pengurus pusat" ? (
                <DownloadPengurusPusat setOpenDownload={setOpenDownload} />
              ) : openDownload === "pengurus provinsi" ? (
                <DownloadPengurusProvinsi setOpenDownload={setOpenDownload} />
              ) : openDownload === "pengurus kabkot" ? (
                <DownloadPengurusKabkot setOpenDownload={setOpenDownload} />
              ) : openDownload === "pengurus kecamatan" ? (
                <DownloadPengurusKecamatan setOpenDownload={setOpenDownload} />
              ) : openDownload === "rekap perempuan" ? (
                <DownloadRekapPerempuan setOpenDownload={setOpenDownload} />
              ) : openDownload === "rekap anggota" ? (
                <DownloadRekapAnggota setOpenDownload={setOpenDownload} />
              ) : openDownload === "daftar anggota" ? (
                <DownloadDaftarAnggota setOpenDownload={setOpenDownload} />
              ) : null}
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default Profile;
